// Gedeelde sorteer-helper voor alle Admin-lijsten:
// compacte "Sorteer op"-dropdown + klikbare kolomheaders (spec: sorteren overal).
export const SORT_OPTIONS = [
  ["first_az", "Voornaam A → Z"],
  ["first_za", "Voornaam Z → A"],
  ["last_az", "Achternaam A → Z"],
  ["last_za", "Achternaam Z → A"],
  ["date_new", "Datum nieuwste → oudste"],
  ["date_old", "Datum oudste → nieuwste"],
];

export const MONEY_OPTIONS = [
  ["date_new", "Datum nieuwste → oudste"],
  ["date_old", "Datum oudste → nieuwste"],
  ["amount_desc", "Bedrag hoog → laag"],
  ["amount_asc", "Bedrag laag → hoog"],
  ["first_az", "Naam / e-mail A → Z"],
  ["first_za", "Naam / e-mail Z → A"],
];

const nl = (s) => (s || "").toLocaleLowerCase("nl-NL");

/* sortRows(list, sort, get) — get: { first, last, date, amount } accessors per rij. */
export function sortRows(list, sort, get) {
  const arr = [...list];
  const str = (fn) => (a, b) => nl(fn(a)).localeCompare(nl(fn(b)), "nl");
  switch (sort) {
    case "first_az": return arr.sort(str(get.first));
    case "first_za": return arr.sort((a, b) => str(get.first)(b, a));
    case "last_az": return arr.sort(str(get.last || get.first));
    case "last_za": return arr.sort((a, b) => str(get.last || get.first)(b, a));
    case "date_old": return arr.sort((a, b) => (get.date(a) || "").localeCompare(get.date(b) || ""));
    case "amount_desc": return arr.sort((a, b) => (get.amount(b) || 0) - (get.amount(a) || 0));
    case "amount_asc": return arr.sort((a, b) => (get.amount(a) || 0) - (get.amount(b) || 0));
    case "date_new":
    default: return arr.sort((a, b) => (get.date(b) || "").localeCompare(get.date(a) || ""));
  }
}

export function SortSelect({ value, onChange, options = SORT_OPTIONS, testid, className = "" }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={`editorial-input dark md:w-64 ${className}`} data-testid={testid}>
      {options.map(([v, l]) => <option key={v} value={v} className="bg-[#0A0A0A]">{l}</option>)}
    </select>
  );
}

/* Klikbare kolomheader: klik wisselt oplopend/aflopend voor deze kolom. */
export function SortHeader({ label, sort, onSort, asc, desc, testid, className = "" }) {
  const active = sort === asc || sort === desc;
  const next = sort === asc ? desc : asc;
  return (
    <button type="button" onClick={() => onSort(next)}
      className={`text-left inline-flex items-center gap-1 transition-colors hover:text-[#F5F3F0] ${active ? "text-[#F5F3F0]" : ""} ${className}`}
      data-testid={testid}>
      {label} <span className="text-[9px]">{active ? (sort === asc ? "▲" : "▼") : "↕"}</span>
    </button>
  );
}

/* Naam-helpers voor records met name en/of first_name/last_name. */
export const firstOf = (d) => d?.first_name || (d?.name || "").trim().split(/\s+/)[0] || "";
export const lastOf = (d) => d?.last_name || (d?.name || "").trim().split(/\s+/).slice(1).join(" ") || "";

/* WhatsApp deep-link: klik op telefoonnummer → wa.me (spec: alle nummers in klantenbestand/profielen). */
export const waLink = (phone) => {
  const d = (phone || "").replace(/[^0-9]/g, "").replace(/^0/, "31");
  return d ? `https://wa.me/${d}` : null;
};
